import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScorecardProfileList extends Layout {
    buttonCalculate: Button;
    buttonDeleteResults: Button;
    layoutheaderCarrierScorecardProfiles: LayoutHeader;
    sourceCarrierScorecardProfile: DataSource;
    tableCarrierScorecardProfiles: Table;
}
